module.exports = __webpack_public_path__ + "img/ai.a4542b38.png";